import {Component, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AgGridAngular} from 'ag-grid-angular';
import {DatosMaestrosService} from 'src/app/services/datos-maestros.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloConciliacionBan} from '../../../diccionarios/conciliacionBancariaModulo';
import {
  ParametroConciliacionBancariaPlusService
} from '../../../services/conciliacion-bancaria/parametro-conciliacion-bancaria-plus.service';
import {ParametrosCBM} from '../../../models/conciliacionbancaria/parametrosCBM';

@Component({
  selector: 'app-parametros-cb',
  templateUrl: './parametros-cb-param.component.html',
  styleUrls: ['./parametros-cb-param.component.css'],
})
export class ParametrosCbParamComponent implements OnInit {
  formulario: FormGroup;
  banderaFormCat = false;
  conciBancaParam: FormGroup;
  mostrarFormulario = false;
  textoBuscar = '';
  textoBanco = 'Bancos*';

  dehabilitarCab;
  habilitarSaldo;
  //btnContinuar = buttons.guardar;
  listConciBancaParamCampo: FormArray;

  // Componentes del Grid
  @ViewChild('agGrid') agGrid: AgGridAngular;
  textBoton = '';
  rowData: ParametrosCBM[] = [];
  DATA_BTNS;
  DATA_MSG;
  DAT_MSG: any;
  DAT_BTNS: any;
  DAT_BTNCSS: any;
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  // Combos
  cmbEmpresa: any[];
  cmbBanco: any[];
  cmbDelimitador: any[];
  cmbValidacion: any[];
  cmbTipoArchivo: any[];
  cmbformatCal: any[];
  cmbOrdenArchivo: any[];
  //inabilitar
  inabilitarSap = false;
  habilitarCatalogo = true;
  bloquearEditar = false;
  //vlidaciondetalle
  validateDetalle = true;
  cmbDatos = [
    {name: 'Fecha', value: 'Fecha'},
    {name: 'Monto', value: 'Monto'},
    {name: 'Movimiento_Bancario', value: 'Movimiento_Bancario'},
    {name: 'Descripcion_Movimiento', value: 'Descripcion_Movimiento'},
    {name: 'Numero_Cheque', value: 'Numero_Cheque'},
    {name: 'Referencia', value: 'Referencia'},
    {name: 'Saldo', value: 'Saldo'},
    //{name: 'Saldo_Apertura', value: 'Saldo_Apertura'},
    {name: 'Signo',value: 'Signo'},
    {name: 'Tipo_Movimiento', value: 'Tipo_Movimiento'},
    {name: 'Valor_Credito', value: 'Valor_Credito'},
    {name: 'Valor_Debito', value: 'Valor_Debito'},
    {name: 'Operacion', value: 'Operacion'},
    {name: 'Informacion_Adicional_1', value: 'Informacion_Adicional_1'},
    {name: 'Informacion_Adicional_2', value: 'Informacion_Adicional_2'},
    {name: 'Informacion_Adicional_3', value: 'Informacion_Adicional_3'},
    {name: 'Informacion_Adicional_4', value: 'Informacion_Adicional_4'},
    {name: 'Nombre_ordenante', value: 'Nombre_ordenante'},
    {name: 'Identificacion_ordenante', value: 'Identificacion_ordenante'}
  ];
  diccionarioModulo: any;
  private editableForm = false;

  constructor(
    private ParametroConciBanca: ParametroConciliacionBancariaPlusService,
    public fb: FormBuilder,
    private _util: UtilsService,
    private _commonForm: CommonFormService,
    private _datosMestros: DatosMaestrosService,
  ) {

    this.diccionarioModulo = moduloConciliacionBan;
    this.DAT_BTNS = moduloConciliacionBan.button.buttonsNombre;
    this.DAT_MSG = moduloConciliacionBan.mensajes;
    this.DAT_BTNCSS = moduloConciliacionBan.button.buttonsCss;

    this.cmbDelimitador = [{id: ',', valor: 'Coma(,)'}, {id: ';', valor: 'Unidades(;)'}, {id: '\t', valor: 'Tab(---)'}];
    this.cmbformatCal = [{id: 'Antecesor', valor: 'Antecesor'}, {id: 'Lineal', valor: 'Lineal'}];
    this.cmbValidacion = [{id: true, valor: 'Si'}, {id: false, valor: 'No'}];
    this.cmbTipoArchivo = [{id: 'Cuerpo', valor: 'Cuerpo'}/*, { id: 'SAP', valor: 'SAP' }*/];
    this.cmbOrdenArchivo = [{id: 'Ascendente', valor: 'Ascendente'}, {id: 'Descendentes', valor: 'Descendentes'}];

    this.formulario = this.fb.group({
      conciBancaParam: this.fb.group({
        idBanco: ['', [Validators.required]],
        idEmpresa: ['', [Validators.required]],
        refBanco: [''],// [Validators.required]],
        claveBanco: ['', [Validators.required, Validators.maxLength(5)]],
        formatoDucumento: ['', [Validators.required]],
        saldoDisponibleInDetalle: ['', [Validators.required]],
        columnaSaldoDispoible: ['', [Validators.required]],
        filaSaldoDisponible: ['', [Validators.required]],
        lineaInicialDatosCabecera: ['', [Validators.required]],
        lineaInicialDatosDetalle: ['', [Validators.required]],
        separador: ['', [Validators.required]],
        formatoCalculo: ['', [Validators.required]],
        ordenDocumento: ['', [Validators.required]]
      }),
      //detalles
      listConciBancaParamCampo: this.fb.array([], [])
    });
  }

  ngOnInit() {
    // this.DAT_BTNS = buttons;
    // this.DAT_MSG = mensajes;
    // this.DAT_BTNCSS = buttonsCss;
    this.cargarGrid();
    this.cargarDatos();
    this.cargarEmpresa();
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'NOMBRE BANCO',
        field: 'conciBancaParam.descBanco',
        sortable: true,
        filter: true,
        // checkboxSelection: true,
        // headerCheckboxSelection: true,
        width: 250
      },
      {
        headerName: 'ID BANCO',
        field: 'conciBancaParam.idBanco',
        sortable: true,
        filter: true,
        width: 150
      },
      // {
      //   headerName: 'ID EMPRESA',
      //   field: 'conciBancaParam.idEmpresa',
      //   sortable: true,
      //   filter: true
      // },
      {
        headerName: 'NOMBRE EMPRESA',
        field: 'conciBancaParam.descEmpresa',
        sortable: true,
        filter: true
      },
      {
        headerName: 'CLAVE BANCO',
        field: 'conciBancaParam.claveBanco',
        sortable: true,
        filter: true
      },
      {
        headerName: 'F.CALCULO',
        field: 'conciBancaParam.formatoCalculo',
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: 'F.DOCUMENTO',
        field: 'conciBancaParam.formatoDucumento',
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.abrirFormularioParaEditarHTML.bind(this),
          label: this.DAT_BTNS.editar,//buttons.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.eliminarElementoColumna.bind(this),
          label: this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: this.DAT_BTNCSS.danger//'btn btn-danger'
        }
      }
    ];
    this.rowSelection = 'multiple';
  }

  cargarDatos() {
    this.ParametroConciBanca.getAll().subscribe((res: any) => {
      this.rowData = res;
    }, (error) => {
      this.rowData = [];
      console.log(error);
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // this.cargarDatos();
    this.restablecerOcultos();
  }

  BancoEmpresa(target) {
    this.cargarBancoEmpresa(this.formulario.get('conciBancaParam.idEmpresa').value);
  }

  getRefBanco(target) {
    let value = this.cmbBanco.find(item => item.idBanco === this.formulario.get('conciBancaParam.idBanco').value);
    this.formulario.get('conciBancaParam.refBanco').setValue(value.refBanco);
    this.formulario.get('conciBancaParam.claveBanco').setValue(value.idBanco);
    this.textoBanco = 'Referencia Banco: ' + value.refBanco + '*';
  }

  cargarBancoEmpresa(inIdEmpresa: string) {
    this._datosMestros.getBancoPorEmpresa(inIdEmpresa).subscribe((resp) => {
      console.log(resp);
      this.cmbBanco = this.concatenarBancoId(resp);
      // this.cmbBanco = resp;
    }, (error) => {
      console.log(error);
    });
  }

  concatenarBancoId(data: any[]) {
    return data = data.map(e => {
      let newDscaBanco = e.idBanco + ' - ' + e.dscaBanco;
      delete e['dscaBanco'];
      e.dscaBanco = newDscaBanco;
      return e;
    });
  }

  cargarEmpresa() {
    this._datosMestros.getAllEmpresas().subscribe((resp) => {
      console.log(resp);
      this.cmbEmpresa = resp;
    }, (error) => {
      console.log(error);
    });
  }

  createDetalle(innIdEmpresa, innIdBanco, refBanco): FormGroup {
    return this.fb.group({
      idEmpresa: [innIdEmpresa, [Validators.required]],
      idBanco: [innIdBanco, [Validators.required]],
      refBanco: [refBanco, [Validators.required]],
      pisicionColumna: [0, [Validators.required, Validators.min(0)]],
      nombreCampo: ['Numero_Cheque', [Validators.required]]
    });
  }

  addDetalle(): void {
    this.listConciBancaParamCampo = this.formulario.get('listConciBancaParamCampo') as FormArray;
    this.listConciBancaParamCampo.push(
      this.createDetalle(
        this.formulario.get('conciBancaParam.idEmpresa').value,
        this.formulario.get('conciBancaParam.idBanco').value,
        this.formulario.get('conciBancaParam.refBanco').value),
    );
    this.onCampoChange({});
  }

  listarParametrosEdit(data) {
    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      this.listConciBancaParamCampo = this.formulario.get('listConciBancaParamCampo') as FormArray;
      this.listConciBancaParamCampo.push(
        this.createDetalleParametros(
          element.idEmpresa,
          element.idBanco,
          element.refBanco,
          element.pisicionColumna,
          element.nombreCampo
        )
      );
    }
    console.log(this.listConciBancaParamCampo);
  }

  createDetalleParametros(innIdEmpresa, innIdBanco, innRefBanco, innPosicion, innNombreCampo): FormGroup {

    return this.fb.group({
      idEmpresa: [innIdEmpresa, [Validators.required]],
      idBanco: [innIdBanco, [Validators.required]],
      refBanco: [innRefBanco, [Validators.required]],
      pisicionColumna: [innPosicion, [Validators.required, Validators.min(0)]],
      nombreCampo: [innNombreCampo, [Validators.required]]
    });
  }

  removeItem(index): void {
    this.listConciBancaParamCampo = this.formulario.get('listConciBancaParamCampo') as FormArray;
    this.listConciBancaParamCampo.removeAt(index);
    this.onCampoChange({});
  }

  selectChangeArchivo() {
    const selected = this.formulario.get('conciBancaParam.formatoDucumento').value;
    if (selected === 'Cuerpo') {
      this.validateDetalle = true;
      this.habilitarCatalogo = false;
      this.dehabilitarCab = true;
      this.inabilitarSap = false;
      this.formulario.controls.conciBancaParam['controls'].lineaInicialDatosCabecera.setValue(0);
    } else if (selected === 'SAP') {
      this.formulario.controls.conciBancaParam['controls'].saldoDisponibleInDetalle.setValue(false);
      this.formulario.controls.conciBancaParam['controls'].columnaSaldoDispoible.setValue(0);
      this.formulario.controls.conciBancaParam['controls'].filaSaldoDisponible.setValue(0);
      this.formulario.controls.conciBancaParam['controls'].lineaInicialDatosCabecera.setValue(0);
      this.formulario.controls.conciBancaParam['controls'].lineaInicialDatosDetalle.setValue(0);
      //agregar
      this.formulario.controls.conciBancaParam['controls'].formatoCalculo.setValue('Antecesor');
      this.formulario.controls.conciBancaParam['controls'].ordenDocumento.setValue('Ascendente');
      this.habilitarCatalogo = true;
      this.inabilitarSap = true;
      this.validateDetalle = false;
      this.dehabilitarCab = true;
      // this.formulario.controls.listConciBancaParamCampo['controls'] = [];
      // this.formulario.get('listConciBancaParamCampo.controls').setValue([]);
      this.limpiarArrayForm();
      this.selectChangeSaldo();
    }

  }

  selectChangeSaldo() {
    if (this.formulario.get('conciBancaParam.saldoDisponibleInDetalle').value === true) {
      this.habilitarSaldo = false;
      this.formulario.controls.conciBancaParam['controls'].filaSaldoDisponible.clearValidators();
      this.formulario.controls.conciBancaParam['controls'].filaSaldoDisponible.setValue('');
      this.formulario.controls.conciBancaParam['controls'].columnaSaldoDispoible.clearValidators();
      this.formulario.controls.conciBancaParam['controls'].columnaSaldoDispoible.setValue('');
    } else {
      this.habilitarSaldo = true;
      this.formulario.controls.conciBancaParam['controls'].columnaSaldoDispoible.setValue(0);
      this.formulario.controls.conciBancaParam['controls'].filaSaldoDisponible.setValue(0);
    }
  }

  onCampoChange(target) {
    const data = this.formulario.getRawValue();
    const isDuplicateCampos = this.checkDuplicateCampos(data.listConciBancaParamCampo);
    // const isDuplicatePosicion = this.checkDuplicatePosicion(data.listConciBancaParamCampo);
    this.validacionDetalle();
    if (isDuplicateCampos) {// || isDuplicatePosicion) {
      setTimeout(() => {
        this.formulario.controls.listConciBancaParamCampo.setErrors({incorrect: true});
      });
    }
  }

  checkDuplicateCampos(a) {
    const counts = [];
    const arr = a.map(item => item.nombreCampo);
    console.log(arr);
    for (let i = 0; i <= arr.length; i++) {
      if (counts[arr[i]] === undefined) {
        counts[arr[i]] = 1;
      } else {
        return true;
      }
    }
    return false;
  }

  checkDuplicatePosicion(a) {
    const counts = [];
    const arr = a.map(item => item.pisicionColumna);
    console.log(arr);
    for (let i = 0; i <= arr.length; i++) {
      if (counts[arr[i]] === undefined) {
        counts[arr[i]] = 1;
      } else {
        return true;
      }
    }
    return false;
  }

  onResetForm() {
    this.formulario.reset();
  }

  actualizarDetalle() {
    let data = this.formulario.value;
    let array_detalle = data.listConciBancaParamCampo;
    for (let i = 0; i < array_detalle.length; i++) {
      const e = array_detalle[i];
      e.idBanco = data.conciBancaParam.idBanco;
      e.idEmpresa = data.conciBancaParam.idEmpresa;
      e.refBanco = data.conciBancaParam.refBanco;
    }
    delete data['listConciBancaParamCampo'];
    data.listConciBancaParamCampo = array_detalle;
    return data;
  }

  devolverObjeto(data): ParametrosCBM {
    console.log(data);
    const enviarObjeto = new ParametrosCBM(data);
    return enviarObjeto;
  }

  SaveForm() {
    let data = this.actualizarDetalle();
    // this._util.confirmarAcyncronico(this, { title: this.DAT_MSG.guardar, text: ``, action: this.DAT_BTNS.guardar }, () => {
    //   return this.ParametroConciBanca.guardarParametros(this.devolverObjeto(data));
    // });
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this.ParametroConciBanca.guardarParametros(this.devolverObjeto(data))
      }).then((response: any) => {
      this.cargarDatos();
      this._commonForm.limpiarYregrear(this);
    }).catch((err) => {
      console.log('cayo un errorsito' + err);
    });
  }

  editarCampo() {
    let data = this.formulario.value;
    // this._util.confirmarAcyncronico(this, { title: this.DAT_MSG.actualizar, text: ``, action: this.DAT_BTNS.editar }, () => {
    //   return this.ParametroConciBanca.actualizarCampo(this.devolverObjeto(data));
    // });
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.editar,
        funcion: this.ParametroConciBanca.actualizarCampo(this.devolverObjeto(data))
      }).then((response: any) => {
      this.cargarDatos();
      this._commonForm.limpiarYregrear(this);
    }).catch((err) => {
      console.log('cayo un errorsito' + err);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        return this.editarCampo();
      } else {
        this.SaveForm();
      }
    } else {
      this.limpiarArrayForm();
      this._commonForm.limpiarYregrear(this);
    }
  }

  limpiarArrayForm() {
    const control = this.formulario.controls.listConciBancaParamCampo as FormArray;
    const len = control.value.length;
    control.value.forEach((x, idx) => {
      control.removeAt(idx - len);
    });
  }

  abrirFormularioParaGuardarHTML() {
    this.bloquearEditar = false;
    this.limpiarArrayForm();
    this._commonForm.abrirFormularioParaGuardar(this);
  }

  abrirFormularioParaEditarHTML({rowData}) {
    this.limpiarArrayForm();
    this.bloquearEditar = true;
    this.editableForm = true;
    this.textBoton = this.DAT_BTNS.editar;//buttons.editar;
    this.mostrarFormulario = true;
    this.formulario.controls.conciBancaParam['controls'].claveBanco.setValue(rowData.conciBancaParam.claveBanco);
    this.formulario.controls.conciBancaParam['controls'].formatoCalculo.setValue(rowData.conciBancaParam.formatoCalculo);
    this.formulario.controls.conciBancaParam['controls'].ordenDocumento.setValue(rowData.conciBancaParam.ordenDocumento);
    this.formulario.controls.conciBancaParam['controls'].formatoDucumento.setValue(rowData.conciBancaParam.formatoDucumento);
    this.formulario.controls.conciBancaParam['controls'].idEmpresa.setValue(rowData.conciBancaParam.idEmpresa);
    this.formulario.controls.conciBancaParam['controls'].refBanco.setValue(rowData.conciBancaParam.refBanco);
    this.formulario.controls.conciBancaParam['controls'].saldoDisponibleInDetalle.setValue(rowData.conciBancaParam.saldoDisponibleInDetalle);
    this.formulario.controls.conciBancaParam['controls'].lineaInicialDatosCabecera.setValue(rowData.conciBancaParam.lineaInicialDatosCabecera);
    this.formulario.controls.conciBancaParam['controls'].lineaInicialDatosDetalle.setValue(rowData.conciBancaParam.lineaInicialDatosDetalle);
    this.formulario.controls.conciBancaParam['controls'].separador.setValue(rowData.conciBancaParam.separador);
    this.selectChangeSaldo();
    this.formulario.controls.conciBancaParam['controls'].columnaSaldoDispoible.setValue(rowData.conciBancaParam.columnaSaldoDispoible);
    this.formulario.controls.conciBancaParam['controls'].filaSaldoDisponible.setValue(rowData.conciBancaParam.filaSaldoDisponible);
    this.cargarBancoEmpresa(this.formulario.get('conciBancaParam.idEmpresa').value);
    this.formulario.controls.conciBancaParam['controls'].idBanco.setValue(rowData.conciBancaParam.idBanco);
    this.selectChangeArchivo();
    this.listarParametrosEdit(rowData.listConciBancaParamCampo);
    this.validateDetalle = false;
  }

  eliminarCampos(idBanco, idEmpresa) {
    return this.ParametroConciBanca.deteleParametros(idBanco, idEmpresa);
  }

  eliminarElementoColumna({rowData}) {
    // this._util.confirmarAcyncronico(this, { title: this.DAT_MSG.eliminar, text: ``, action: this.DAT_BTNS.eliminar }, () => {
    //   return this.eliminarCampos(rowData.paramConciliacionComp.idBanco, rowData.paramConciliacionComp.idEmpresa);
    // }, () => {
    //   // console.log('elimanado');
    //   this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
    //   // return this.cargarDatos();
    // });
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: '',
        action: this.DAT_BTNS.eliminar,
        funcion: this.eliminarCampos(rowData.conciBancaParam.idBanco, rowData.conciBancaParam.idEmpresa)
      }).then((response: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
    }).catch((err) => {
      console.log('cayo un errorsito' + err);
    });
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  restablecerOcultos() {
    this.inabilitarSap = false;
    this.habilitarCatalogo = true;
  }

  validacionDetalle() {
    let Referencia = false;
    let Monto = false;
    let Fecha = false;
    let Saldo = false;
    let Movimiento_Bancario = false;
    let Valor_Credito = false;
    let Valor_Debito = false;
    this.validateDetalle = true;
    const arrayComparacion = this.listConciBancaParamCampo.value;
    for (let i = 0; i < arrayComparacion.length; i++) {
      const e = arrayComparacion[i];
      switch (e.nombreCampo) {
        case 'Referencia':
          Referencia = true;
          break;
        case 'Valor_Credito':
          Valor_Credito = true;
          break;
        case 'Valor_Debito':
          Valor_Debito = true;
          break;
        case 'Monto':
          Monto = true;
          break;
        case 'Fecha':
          Fecha = true;
          break;
        case 'Saldo':
          Saldo = true;
          break;
        case 'Movimiento_Bancario':
          Movimiento_Bancario = true;
          break;
        default:
          break;
      }
    }
    if (Monto) {
      if (Saldo && Monto && Fecha) {
        this.validateDetalle = false;
      }
    } else if (Valor_Debito || Valor_Credito) {
      if (Valor_Debito && Valor_Credito && Fecha && Saldo && Movimiento_Bancario) {
        this.validateDetalle = false;
      }
    }
  }

}




